// extracted by mini-css-extract-plugin
export var actionButton = "_id-t";
export var buttonContainer = "_id-0";
export var buttonContainer2 = "_id-1";
export var buttonSection = "_id-2";
export var details = "_id-3";
export var dropdownItem = "_id-5";
export var dropdownItemsContainer = "_id-4";
export var fileInput = "_id-r";
export var headerButton = "_id-6";
export var icon = "_id-7";
export var input = "_id-8";
export var macroListItem = "_id-9";
export var mainContent = "_id-a";
export var microText = "_id-b";
export var modal = "_id-w";
export var optionsButton = "_id-c";
export var paperclip = "_id-s";
export var pillContent = "_id-d";
export var preview = "_id-e";
export var preview2 = "_id-f";
export var quillEditor = "_id-q";
export var selectedMacro = "_id-g";
export var sidebar = "_id-h";
export var sidebarHeader = "_id-j";
export var sidebarList = "_id-i";
export var sidebarListItem = "_id-k";
export var sidebarSearch = "_id-l";
export var snoozeDurationWrapper = "_id-v";
export var statusPillContainer = "_id-m";
export var tagsContainer = "_id-n";
export var unselectedMacro = "_id-o";
export var variable = "_id-u";
export var wrapper = "_id-p";